// Jarvis (antigo)
// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
// import { Observable } from 'rxjs';
// import { urlApi } from '../../../utils/apiConfig';
//
// interface UpdateAttributes {
  // nome: string;
  // telefone: string;
  // cpfcnpj: string;
  // host: string;
  // password: string;
// }
//
// @Injectable()
// export class ProfileService { 
  // constructor(private http: HttpClient) { }
//
  // public getUser(): Observable<any>{
    // return this.http.get(urlApi+'/app/user')
  // }
//
  // public updateuser(data: UpdateAttributes): Observable<any>{
    // return this.http.patch(urlApi+'/app/user', data );
  // }
// }
//

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { urlApi } from '../../../utils/apiConfig';

interface UpdateAttributes {
  nome: string;
  telefone: string;
  cpfcnpj: string;
  host: string;
  password: string;
  generalKey?: string | null;
}

@Injectable()
export class ProfileService { 
  constructor(private http: HttpClient) { }

  public getUser(): Observable<any>{
    return this.http.get(urlApi+'/app/user')
  }

  public updateuser(data: UpdateAttributes): Observable<any>{
    return this.http.patch(urlApi+'/app/user', data );
  }
}
